// extracted by mini-css-extract-plugin
export default {"eventList":"eventList_eventList__OWz95","title":"eventList_title__F1pYd","item":"eventList_item__PtWka"};